import { TypeIds } from "src/app/inventory/sales-order/constants/constants";
import { IProductCalculationContext } from "../models/product-calculation-context.model";
import { ProductsCalculationUtilsService } from "../service/products-calculation-utils.service";
import { ProductTotalCalculationStrategy } from "./product-total-strategy";

export class BundleInnerProductCalculationStrategy implements ProductTotalCalculationStrategy {
    constructor(private productsCalculationUtilsService: ProductsCalculationUtilsService) {}

    calculateTotal(context: IProductCalculationContext): void {
        const { product, allTaxRates, zipcode, stateId, taxSettings, taxConfig, taxEnabled, isVisibleRowTax } = context;

        if (product && product?.parentTypeId !== TypeIds.KitTypeId) {
            let subTaxes = this.productsCalculationUtilsService.getProductsApplicableSubTaxes(product, allTaxRates, zipcode, stateId, taxSettings, taxConfig);
            if(product?.uomId) {
                product.unit = product?.uomList?.find((uom) => uom?.unitOfMeasureId === product?.uomId);
            }
            
            const uomValue = product?.unit?.uomDetail?.value ?? 1;
            product.qty = product?.qty ?? 1;
            product.totalQuantity = (product?.qty ?? 1) * uomValue;
            let subTotal = Number(product.price) * Number(product.totalQuantity);
            product.baseSubTotal = subTotal;
            product.selectedBin = this.productsCalculationUtilsService.setBin(product.totalQuantity, product.binDetails);
            product.totalCostPrice = Number(product.costPrice) * Number(product.totalQuantity);

            if (product?.discountType && product?.discountType?.isTaxable) {
                let discount = this.productsCalculationUtilsService.calculateDiscount(product?.discountType?.name, product.discountRate, subTotal);
                product.discountAmount = discount;
                subTotal = subTotal - discount;

                if (product?.handlingFeeType && product?.handlingFeeType?.isTaxable) {
                    let handlingFee = this.productsCalculationUtilsService.calculateDiscount(product?.handlingFeeType?.type?.name, product.handlingFeeRate, subTotal);
                    product.handlingFeeAmount = handlingFee;
                    subTotal = subTotal + handlingFee;
                }

                let productsTotalTax = 0;
                if (taxEnabled && isVisibleRowTax) {
                    subTaxes?.forEach((sTax: any) => {
                        const taxAmount = this.productsCalculationUtilsService.calculateProductsTax(sTax.taxRate, subTotal);
                        productsTotalTax += taxAmount;
                        sTax["taxAmount"] = taxAmount;
                    });
                    subTotal = subTotal + productsTotalTax;
                }

                if (product?.handlingFeeType && !product?.handlingFeeType?.isTaxable) {
                    let handlingFee = this.productsCalculationUtilsService.calculateDiscount(product?.handlingFeeType?.type?.name, product.handlingFeeRate, subTotal);
                    product.handlingFeeAmount = handlingFee;
                    subTotal = subTotal + handlingFee;
                }

                if(!product?.handlingFeeType){
                    product.handlingFeeAmount = 0;
                }

                product.subTotal = subTotal;
                product.taxAmount = productsTotalTax;
                product["subTaxes"] = subTaxes;
                product["totalAmount"] = subTotal;
            } else {
                if (product?.handlingFeeType && product?.handlingFeeType?.isTaxable) {
                    let handlingFee = this.productsCalculationUtilsService.calculateDiscount(product?.handlingFeeType?.type?.name, product.handlingFeeRate, subTotal);
                    product.handlingFeeAmount = handlingFee;
                    subTotal = subTotal + handlingFee;
                }

                let productsTotalTax = 0;
                if (taxEnabled && isVisibleRowTax) {
                    subTaxes?.forEach((sTax: any) => {
                        const taxAmount = this.productsCalculationUtilsService.calculateProductsTax(sTax.taxRate, subTotal);
                        productsTotalTax += taxAmount;
                        sTax["taxAmount"] = taxAmount;
                    });
                    subTotal = subTotal + productsTotalTax;
                }

                let discount = this.productsCalculationUtilsService.calculateDiscount(product?.discountType?.name, product.discountRate, subTotal);
                product.discountAmount = discount;
                subTotal = subTotal - discount;

                if (product?.handlingFeeType && !product?.handlingFeeType?.isTaxable) {
                    let handlingFee = this.productsCalculationUtilsService.calculateDiscount(product?.handlingFeeType?.type?.name, product.handlingFeeRate, subTotal);
                    product.handlingFeeAmount = handlingFee;
                    subTotal = subTotal + handlingFee;
                }

                if(!product?.handlingFeeType){
                    product.handlingFeeAmount = 0;
                }

                product.subTotal = subTotal;
                product.taxAmount = productsTotalTax;
                product["subTaxes"] = subTaxes;
                product["totalAmount"] = subTotal;
            }

            if (product.bundleDetails?.length > 0) {
                for (let kp of product.bundleDetails) {
                    kp.show = false;
                    kp.selectedBin = this.productsCalculationUtilsService.setBin(kp.totalQuantity, kp.binDetails);
                    for (let kit of kp.bundleDetails) {
                        kit.selectedBin = this.productsCalculationUtilsService.setBin(kit.totalQuantity, kit.binDetails);
                    }
                }
            }
        }
    }
}
